import React from "react";
import { Configurable } from "./Configurable";
import { AppearanceTextarea } from "./fields/AppearanceTextarea";

/**
 * Applies maximum length to input field
 */
export class Description extends Configurable {
    public schema;
    public designer;
    public field;
    public defaultValue;

    public keyName = "description";
    public title = "Beschreibung";
    public description = "Hier können Sie eine erweiterte Beschreibung für das Feld angeben";
    public value = "";

    public EditComponent({
        register,
        schema,
        designer,
        field,
    }: {
        register: any;
        schema: any;
        designer: any;
        field: any;
    }): any {
        return (
            <AppearanceTextarea
                register={register}
                value={field.rawOptions[this.keyName]}
                placeholder={this.title}
                field={field}
                keyName={this.keyName}
            />
        );
    }

    public sleepValue(value): any {
        return value;
    }

    public wakeValue(value) {
        return value;
    }
}
